import { render, staticRenderFns } from "./checkLicense.vue?vue&type=template&id=659968a2&scoped=true&"
import script from "./checkLicense.vue?vue&type=script&lang=js&"
export * from "./checkLicense.vue?vue&type=script&lang=js&"
import style0 from "./checkLicense.vue?vue&type=style&index=0&id=659968a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659968a2",
  null
  
)

export default component.exports